import * as Redux from 'redux';
import { BusinessActionTypes, BusinessState, BusinessResponse } from './business.types';
import {
  initialBusinessState,
  GET_BUSINESS,
  REGISTER_OR_UPDATE_BUSINESS,
  VALIDATE_PHONE,
  GET_STATEMENTS
} from './business.constants';
import { ReduxAction, SimpleResponse } from '../app/app.types';
import { REVERT_TO_INITIAL_STATE, REVERT_TO_INITIAL_STATE_EXCEPT_AUTH } from '../app/app.const';

const businessReducer: Redux.Reducer<BusinessState> = 
  (businessState: BusinessState = initialBusinessState,
   action: ReduxAction<BusinessActionTypes, SimpleResponse<BusinessResponse>>): BusinessState => {
  switch (action.type) {
    case `${GET_BUSINESS}_FULFILLED`:
      return { ...businessState,
        statusCode: action.payload.statusCode,
        business: action.payload.body.entity
      };
    case `${REGISTER_OR_UPDATE_BUSINESS}_FULFILLED`:
      if (action.payload.statusCode === 417) {
        return { ...businessState,
          statusCode: action.payload.statusCode,
        };
      } else {
        return { ...businessState,
          statusCode: action.payload.statusCode,
          business: action.payload.body.entity
        };
      }
    case `${VALIDATE_PHONE}_FULFILLED`:
      return { ...businessState,
        validation: {
          phoneNumberValidationStatus: action.payload.statusCode
        }
      };
    case `${GET_STATEMENTS}_FULFILLED`:
      return { ...businessState,
        statusCode: action.payload.statusCode,
        statements: action.payload.body.list
      };
    case REVERT_TO_INITIAL_STATE_EXCEPT_AUTH:
      return initialBusinessState;
    case REVERT_TO_INITIAL_STATE:
      return initialBusinessState;
    default:
      return businessState;
  }
};

export default businessReducer;


// WEBPACK FOOTER //
// ./src/business/business.reducer.tsx